class RsBundleForm extends HTMLElement {
  static RS_BUNDLE_DISABLED = 'data-rs-bundle-disabled';
  static RS_BUNDLE_ATC = 'data-rs-bundle-atc';
  static RS_BUNDLE_ERROR_SELECTOR = '[data-rs-bundle-error]';
  static RS_BUNDLE_HIDDEN = 'hidden';
  static RS_BUNDLE_GIFT_TEXT = 'rs-bundle-gift-text';
  static RS_BUNDLE_ERROR_DEFAULT = 'An error occurred while creating your bundle. Please refresh the page and try again.';
  static RS_BUNDLE_CONFIG_NOT_AVAILABLE = 'This bundle configuration is not available. Please refresh the page and try another combination.';

  static get observedAttributes() {
    return [RsBundleForm.RS_BUNDLE_DISABLED];
  }
  constructor() {
    super();

    this.groupedProducts = [];
    this.isValidBundle = false;
    this.lowestPriceItem = Infinity;
    this.selectedOptions = {};
    this.actualPrice = 0;
    this.comparePrice = 0;
  }
    
  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.bundleForm = this.querySelector('form');
      this.bundleAtc = this.querySelector(`[${RsBundleForm.RS_BUNDLE_ATC}]`);
      this.bundleError = this.querySelector(`${RsBundleForm.RS_BUNDLE_ERROR_SELECTOR}`);
      this.bundleForm?.addEventListener('submit', this.onSubmitHandler.bind(this));

      if (this.bundleError && !this.bundleError.dataset.rsBundleErrorDefault) {
        this.bundleError.dataset.rsBundleErrorDefault = RsBundleForm.RS_BUNDLE_ERROR_DEFAULT;
      }

      try {
        this.bundleFormProducts = JSON.parse(this.querySelector('[data-bundle-info]')?.textContent);
      } catch (error) {
          console.error("Error parsing JSON in component-rs-bundle-form:", error);
          this.bundleFormProducts = {};
      }
    
      //re-organize all product_data by the group
      this.bundleFormProducts &&  this.groupByGroup(this.bundleFormProducts?.product_data)
      this.groupedItems && this.addMinMaxToGroup(this.bundleFormProducts?.group_data);
      this.gwpType = this.bundleFormProducts?.group_data?.gwp_type;
      this.isAvailable = this.bundleFormProducts?.group_data?.is_available;
      this.discountType = this.bundleFormProducts?.group_data?.discount_type;
      this.discountValue = this.bundleFormProducts?.group_data?.discount_value;

      this.addEventListener('change', (e) => {
        this.updateOnUserSelection(e)
      })

      document.addEventListener('RS:CartItemRemoved', (e) => {
        window.RS?.helpers?.removeCartAttribute?.(e);
      })

      document.addEventListener('RS:CartItemAdded', (e) => {
        this.addCartAttribute(e);
      })

    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === RsBundleForm.RS_BUNDLE_DISABLED) {
      this.onRsBundledDisabledChange(newValue);
    }
  }

  onRsBundledDisabledChange(newValue) {
    if (this.bundleError) {
      if (!this.bundleError.dataset.rsBundleErrorDefault) {
        this.bundleError.dataset.rsBundleErrorDefault = RsBundleForm.RS_BUNDLE_ERROR_DEFAULT;
      }
      if (!this.bundleError.dataset.rsBundleErrorMsg) {
        this.bundleError.dataset.rsBundleErrorMsg = this.bundleError.dataset.rsBundleErrorDefault;
      }
    }

    if (newValue === 'true') {
      if (this.bundleAtc) {
        this.bundleAtc.setAttribute('disabled', true);
        this.bundleAtc.setAttribute('type', 'button');
      }

      if (this.bundleError) {
        this.bundleError.innerHTML = this.bundleError.dataset.rsBundleErrorMsg || RsBundleForm.RS_BUNDLE_ERROR_DEFAULT;
        this.bundleError.classList.remove(RsBundleForm.RS_BUNDLE_HIDDEN);
      }
    }
  }

  addCartAttribute(e) {
    const {lineItem} = e?.detail || {};
    
    if (lineItem?.properties?.['_bundle_config_order']) {
      const key = `_bundle_${lineItem.properties['_bundle_config']?.bundle_id}`;
      const cartAttributeToAdd = {
        [key]: lineItem.properties['_bundle_config_order']
      }
      window.RS?.halo?.modifyCartAttributes(cartAttributeToAdd)
    }
  }
  
  onSubmitHandler(e) {
    e.preventDefault();
    const context = this;
    const targetBtn = this.bundleAtc;
    targetBtn && targetBtn.classList.add('is-loading');
    const bundleVariantId = this.bundleFormProducts?.group_data?.bundle_variant_id;
    const timestamp = Date.now();

    const properties = this.structureLineItemProperties(bundleVariantId, timestamp);
    properties['_bundle_config'] = properties['_bundle_config'];
    properties['_bundle_config_json'] = JSON.stringify(properties['_bundle_config']);

    /* Workaround to include additional bundle definition data. Adding as a snapshot of bundle
    * definition at the time of adding to cart. Don't want to include at line
    * item property to limit the payload pulled in by the cart transform input query.
    * Also as some of the information is pulled from backend data and
    * revalidated in cart transform anyways. If bundle definition changes by the
    * time the user gets to checkout, this data may diverge from the final bundle.
    * This is a temporary solution until Shopify rolls out adding line attributes
    * to cart transform expand/merge items. March 2024
    */ 
    properties['_bundle_config_order'] = {
      ...(properties['_bundle_config'] || {}),
      discount_type: this.discountType,
      discount_amount: this.discountValue,
      gwp_type: this.gwpType,
      component_references_quantity: this.bundleFormProducts?.group_data?.group_count,
    };

    for (let i = 1; i <= this.bundleFormProducts?.group_data?.group_count; i++) {
      if (this.bundleFormProducts?.group_data?.[`component_reference_${i}`]) {
        properties[`_bundle_config_order`][`component_quantities_${i}`] = this.bundleFormProducts?.group_data?.[`component_reference_${i}`];
      }
    }

    Shopify.addItem(bundleVariantId, 1, window.RS.halo.addItemCB, null, properties).catch((error) => {
      if (context?.bundleError?.dataset) {

        // check if error message contains the string sold out
        if (error.responseJSON?.description?.includes('sold out') || error.responseJSON?.description?.includes('in your cart') || error.responseJSON?.description?.includes("can't add more")) {
          context.bundleError.dataset.rsBundleErrorMsg = RsBundleForm.RS_BUNDLE_CONFIG_NOT_AVAILABLE;
        } else {
          context.bundleError.dataset.rsBundleErrorMsg = context.bundleError.dataset.rsBundleErrorDefault || RsBundleForm.RS_BUNDLE_ERROR_DEFAULT;
        }

        context.dataset.rsBundleDisabled = true;
      }
    });
  }

  getAutoLowestPricedItem() {
    let lowestData;
    if (this.gwpType === 'auto-lowest-priced-item') {
      const keys = Object.keys(this.selectedOptions || {});
      let lowestPrice = Infinity;
      let lowestPricedId = null;
      let lowestPricedQty = 0;

      keys.forEach((key) => {
        const { originalPrice, quantity } = this.selectedOptions[key] || {};
        const id = key.split('-')[0];

        if (originalPrice !== null && originalPrice !== undefined && originalPrice !== '') {
          if (originalPrice < lowestPrice) {
            lowestPrice = originalPrice;
            lowestPricedId = id;
            lowestPricedQty = quantity;
          } else if (originalPrice === lowestPrice && quantity < lowestPricedQty) {
            lowestPricedId = id;
            lowestPricedQty = quantity;
          }
        }
      });

      if (lowestPricedId) {
        lowestData = {
          id: lowestPricedId,
          price: lowestPrice
        };
      }
    }

    return lowestData;
  }

  structureLineItemProperties(id, timestamp) {
    const lowestData = this.getAutoLowestPricedItem();
    let lowestCount = 0;

    const structured_config = 
    {
      _bundle_config: {
        bundle_id: `${id}_${timestamp}`,
        parent_id: id,
        actual_price: this.actualPrice,
        compare_price: this.comparePrice,
      }
    }

    const keys = Object.keys(this.selectedOptions || {});
    keys.forEach((key) => {
      const {group, unitPrice, price, quantity, src, title, originalPrice} = this.selectedOptions[key];
      const structured_config_value = {
        id: key.split('-')[0],
        price: originalPrice,
        src,
        title
      }

      !structured_config._bundle_config?.[group] && (structured_config._bundle_config[group] = []);
      
      const currentGroupArr = structured_config._bundle_config?.[group];
      currentGroupArr.push(...Array(quantity).fill(structured_config_value));

      // If lowestData id is the same as structured_config_value id and lowestCount is 0, add a lowestPriced property of true to the last currentGroupArr item
      if (lowestData?.id === structured_config_value.id && !lowestCount) {
        lowestCount++;

        if (currentGroupArr[currentGroupArr.length - 1]) {
          currentGroupArr[currentGroupArr.length - 1] = {
            ...currentGroupArr[currentGroupArr.length - 1],
            lowestPriced: true
          };
        }
      }
    });

    return structured_config;
  }


  groupByGroup(data) {
    const groupedItems = {};
    const keys = Object.keys(data || {});

    for (const key of keys) {
      const item = data[key];
      const group = item.group;

      if (!groupedItems[group]) {
          groupedItems[group] = {};
      }

      const groupKey = key.includes('gwp') ? key.split('_')[1] : key;
      groupedItems[group][groupKey] = item;
    }
    this.groupedItems = Object.keys(groupedItems).length ? groupedItems : null;
  }

  addMinMaxToGroup(data) {
    const keys = Object.keys(data || {});

    for (const key of keys) {
      const group = data[key];
      const groupItems = this.groupedItems?.[key];

      if (groupItems) {
        groupItems.min = group[0];
        groupItems.max = group[1];
      }
    }

    if (this.groupedItems?.gwp) {
      this.groupedItems.gwp.min = 1;
    } 
  }
  
  getValueOfSelectedOption(e) {
    if (e?.target?.matches('select')) {
      const selectedValue = e.target.value;
      const selectedGroup = e.target.dataset.parent;
      const selectedOption = this.bundleFormProducts?.product_data?.[selectedGroup !== 'gwp' ? selectedValue : `${selectedGroup}_${selectedValue}`] || {};
      const price = selectedOption?.price || 0;
      const title = selectedOption?.title || '';
      const discountedPrice = selectedOption?.discounted_price || 0;
      const imageSrc = 
        this.bundleFormProducts?.product_data?.[selectedValue]?.image 
        ? this.bundleFormProducts?.product_data?.[selectedValue]?.image 
        : this.bundleFormProducts?.product_data?.[`gwp_${selectedValue}`]?.image 
        ? this.bundleFormProducts?.product_data?.[`gwp_${selectedValue}`]?.image 
        : '';
      
      if (selectedValue !== undefined && selectedValue !== '') {
        this.lowestPriceItem = (discountedPrice < this.lowestPriceItem && discountedPrice > 0) ? discountedPrice : this.lowestPriceItem;
        return {
          group: selectedGroup, 
          value: selectedValue, 
          price: price, 
          discountedPrice: discountedPrice,
          src: imageSrc,
          title: title
        };
      }
      return {}
    }
  }

  getAllSelectedOptions() {
    const bundleSelectEls = this.querySelectorAll('.rs-bundle-form__select-list[data-parent]');
    const selectedOptions = [...bundleSelectEls].reduce((acc, selectList) => {
      const {group, value, price, discountedPrice, src, title} = this.getValueOfSelectedOption({target: selectList});
      if (value && value !== '0') {
        const key = `${value}-${group}`;
        acc[key] = acc[key] 
          ? {
              compareAtPrice: acc[key]?.compareAtPrice + parseFloat(price || 0),
              actualPrice: acc[key]?.actualPrice + parseFloat(discountedPrice || 0),
              unitPrice: parseFloat(discountedPrice) || parseFloat(price),
              quantity: acc[key]?.quantity + 1,
              originalPrice: parseFloat(price),
              group,
              src,
              title
            } 
          : {
              compareAtPrice: parseFloat(price), 
              actualPrice: parseFloat(discountedPrice),
              unitPrice: parseFloat(discountedPrice) || parseFloat(price),
              originalPrice: parseFloat(price),
              quantity: 1,
              group, 
              src,
              title
            };
      }
      return acc;
    }, {});
    return selectedOptions;
  }

  updateOnUserSelection(e) {
    const targetSelectList = e.target;
    const targetSelectWrapper = targetSelectList.closest('.rs-bundle-form__select-wrapper');
    const {group, value} = this.getValueOfSelectedOption(e);
    const selectedItemData = this.groupedItems?.[group]?.[value];
    
    if (targetSelectList) {
      this.updateSelectImage(targetSelectList, selectedItemData)
    }

    if (targetSelectWrapper) {
      targetSelectWrapper.setAttribute('data-item-selected', value);
    }

    this.isAvailable && this.setAtcButtonState();
    this.setVisiblePrice();

    if (this.gwpType === 'auto-lowest-priced-item') {
      if (this.isValidBundle) {
        this.addFreeItemText();
      } else {
        this.removeFreeItemText();
      }
    }
  }

  updateSelectImage(selectList, selectedItemData) {
    const {image} = selectedItemData || {};
    const selectListImageEl = selectList.closest('.rs-bundle-form__select-wrapper').querySelector('.rs-bundle-form__image img');
    const defaultImg = this.bundleFormProducts?.group_data?._default_img || '';
    
    if (selectListImageEl) {

      selectListImageEl.setAttribute('src', image || defaultImg || '');
      selectListImageEl.style.width = image || defaultImg ? '75px' : '0px';
    }
  }

  setAtcButtonState() {
    const bundleSelectEls = this.querySelectorAll('.rs-bundle-form__select-list[data-parent]');
    // const atcButton = this.querySelector('.product-form__buttons button[type="submit"]');
    const atcButton = this.bundleAtc;
    this.isValidBundle = true;

    if (this.dataset.rsBundleDisabled !== 'true') {
      //Count number of selected options for each group
      const numOfSelectedOptions = [...bundleSelectEls].reduce((acc, selectList) => {
        const {group, value} = this.getValueOfSelectedOption({target: selectList});
        
        if( !acc.hasOwnProperty(group) && value === '0') {
          acc[group] = 0;
        }
        
        if (group && value !== '0') {
          acc[group] = acc[group] ? acc[group] + 1 : 1;
        }
        
        return acc;
      }, {});
  
      //Check if minimum quantity is met for each group
      const keys = Object.keys(numOfSelectedOptions || {});
      
      for (const key of keys) {
        const numOfSelectedOption = numOfSelectedOptions[key];
        const group = this.groupedItems[key];
  
        if (numOfSelectedOption < group.min) {
          this.isValidBundle = false;
          break;
        }
      }
    } else {
      this.isValidBundle = false;
    }

    if (this.isValidBundle) {
      atcButton?.removeAttribute('disabled');
    } else {
      atcButton?.setAttribute('disabled', true);
    }
    
  }

  getCumulativePrices() {
    this.selectedOptions = this.getAllSelectedOptions();
    const cumulativePrices = Object.keys(this.selectedOptions).reduce((acc, key) => {
      const {actualPrice, compareAtPrice} = this.selectedOptions[key];
      const isGWP = key.includes('gwp');
      
      acc.actualPrice += parseFloat(isGWP ? 0 : this.discountType === 'percentage' ? actualPrice : compareAtPrice);
      acc.comparePrice += parseFloat(compareAtPrice);

      return acc;
    }, {actualPrice: 0, comparePrice: 0});

    cumulativePrices.actualPrice = this.gwpType === 'auto-lowest-priced-item' 
      ? cumulativePrices.actualPrice - this.lowestPriceItem
      : cumulativePrices.actualPrice;
    cumulativePrices.comparePrice = cumulativePrices.comparePrice.toFixed(2);

    if (this.discountType === 'fixed_amount') {
      cumulativePrices.actualPrice = cumulativePrices.actualPrice - this.discountValue;
    }

    if (cumulativePrices.actualPrice < 0) {
      cumulativePrices.actualPrice = 0.00;
    }

    cumulativePrices.actualPrice = cumulativePrices.actualPrice.toFixed(2);
    
    return cumulativePrices;
  }

  setVisiblePrice() {
    const actualPriceEl = this.querySelector('.rs-bundle-price__price');
    const comparePriceEl = this.querySelector('.rs-bundle-price__compare-at');
    const savingsPriceEl = this.querySelector('.rs-bundle-price__savings');
    const startingPriceEl = this.querySelector('.rs-bundle-price__starting');
    const {actualPrice, comparePrice} = this.getCumulativePrices();
    this.actualPrice = actualPrice;
    this.comparePrice = comparePrice;
    
    if (this.isValidBundle) {
      const savings = actualPrice && comparePrice ? (comparePrice - actualPrice).toFixed(2) : '';
      const savingsText = savings ? `Save $${savings}` : '';
      if (savingsPriceEl) {
        savingsPriceEl.textContent = savingsText;
        savingsPriceEl.classList.remove(RsBundleForm.RS_BUNDLE_HIDDEN);
      }
      actualPriceEl && actualPrice && (actualPriceEl.textContent = `$${actualPrice}`);
      comparePriceEl && comparePrice && (comparePriceEl.textContent = `($${comparePrice} Retail Value)`);
      actualPriceEl && actualPriceEl.classList.remove(RsBundleForm.RS_BUNDLE_HIDDEN);
      comparePriceEl && comparePriceEl.classList.remove(RsBundleForm.RS_BUNDLE_HIDDEN);
      startingPriceEl && startingPriceEl.classList.add(RsBundleForm.RS_BUNDLE_HIDDEN);

    } else {
      actualPriceEl && actualPriceEl.classList.add(RsBundleForm.RS_BUNDLE_HIDDEN);
      comparePriceEl && comparePriceEl.classList.add(RsBundleForm.RS_BUNDLE_HIDDEN);
      startingPriceEl && startingPriceEl.classList.remove(RsBundleForm.RS_BUNDLE_HIDDEN);
      savingsPriceEl && savingsPriceEl.classList.add(RsBundleForm.RS_BUNDLE_HIDDEN);
    }
  }

  addFreeItemText() {
    const { id } = this.getAutoLowestPricedItem() || {};
    const targetFreeGiftTextEl = id ? this.querySelector(`[data-item-selected="${id}"] .${RsBundleForm.RS_BUNDLE_GIFT_TEXT}`) : null;
    const freeGiftTextEls = this.querySelectorAll(`.rs-bundle-form__select-wrapper .${RsBundleForm.RS_BUNDLE_GIFT_TEXT}`);

    if (freeGiftTextEls) {
      [...freeGiftTextEls].forEach((el) => {
        el.classList.add('hidden');
      });
    }
    
    if (targetFreeGiftTextEl) {
      targetFreeGiftTextEl.classList.remove('hidden');
    }
  }

  removeFreeItemText() {
    const freeGiftTextEls = this.querySelectorAll(`.${RsBundleForm.RS_BUNDLE_GIFT_TEXT}:not(.${RsBundleForm.RS_BUNDLE_HIDDEN})`);
    freeGiftTextEls?.forEach((el) => {
      el.classList.add(RsBundleForm.RS_BUNDLE_HIDDEN);
    });
  }
}

customElements.define('rs-bundle-form', RsBundleForm);